/**
 * DSCheckbox Component
 *
 * Checkbox wrapper using design system styling.
 * Can be used individually or in groups.
 *
 * Usage (single):
 * <DSCheckbox
 *   label="I agree to terms"
 *   checked={agreed}
 *   onChange={(e) => setAgreed(e.target.checked)}
 * />
 *
 * Usage (group):
 * <div>
 *   {options.map(opt => (
 *     <DSCheckbox
 *       key={opt.value}
 *       label={opt.label}
 *       checked={selected.includes(opt.value)}
 *       onChange={(e) => handleChange(opt.value, e.target.checked)}
 *     />
 *   ))}
 * </div>
 */

import React from 'react';
import PropTypes from 'prop-types';

export function DSCheckbox({
  label,
  checked,
  onChange,
  disabled,
  className = '',
  ...otherProps
}) {
  return (
    <label className={`check-group ${className}`} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <div className={`check-box${checked ? ' checked' : ''}`} />
      <span
        className="check-label"
        style={{
          opacity: disabled ? 0.65 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {label}
      </span>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ display: 'none' }}
        {...otherProps}
      />
    </label>
  );
}

DSCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};


export default DSCheckbox;
